<template>
  <div>
    <ul class="cards">
      <div
        v-if="isLinkedCard"
        v-m-b="10"
        v-cursor:pointer
        @click="refundDebit"
      >
        <selectable-card-panel
          :card="getLinkedCard"
        />
      </div>

      <li class="default" @click="goBill">
        <div class="project-icon">
          <span class="emoji">&nbsp;💳</span>
          <div class="background cover">
            <span>{{ $t('choose.or.add.card') }}</span>
          </div>
        </div>
        <div>
          <div>
            <span>{{ $t('from.another.card') }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SelectableCardPanel from 'organisms/card/SelectableCardPanel';

export default {
  name: 'BalanceReplenishment',
  components: {
    SelectableCardPanel,
  },
  props: {
    loading: Boolean,
  },
  data() {
    return {
      reason: '',
    };
  },
  computed: {
    isLinkedCard() {
      return !this.isNoLinkedCards;
    },
    isInvalidCard() {
      return this.isLinkedCardIsExpired || this.isLinkedCardInBlacklisted;
    },
    ...mapGetters('cards', [
      'getLinkedCard',
      'isNoLinkedCards',
      'isLinkedCardIsExpired',
      'isLinkedCardInBlacklisted',
    ]),
  },
  methods: {
    goBill() {
      this.$emit('refund-bill');
    },
    refundDebit() {
      if (this.loading || this.isInvalidCard) {
        return false;
      }

      this.$emit('refund-debit', this.getLinkedCard.id);
    },
  },
};
</script>
